import { useTranslation } from 'react-i18next'
import { ShieldAlert } from 'lucide-react'

export function ReadOnlyBanner() {
  const { t } = useTranslation('settings')

  return (
    <div className="flex items-start gap-3 rounded-lg border-l-4 border-border bg-muted px-4 py-3 text-muted-foreground">
      <ShieldAlert size={18} className="mt-0.5 shrink-0" />
      <div>
        <p className="text-sm font-semibold text-foreground">{t('rbac.title')}</p>
        <p className="mt-0.5 text-sm">{t('rbac.body')}</p>
      </div>
    </div>
  )
}
